/** Design values for the shared exceptions list. Consumed only by exceptions.list.component.less. */
import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const exceptionsListStyleId = 'wb-v2-schedule-exceptions-list-theme';

export const exceptionsListBridgeStyles = {
  'wb-schedule-exceptions-list': {
    '--local-exceptions-radius': tokens.radius.md,
    '--local-exceptions-border': tokens.color.border.secondary,
    '--local-exceptions-bg': tokens.color.background.primary,
    '--local-exceptions-font-family': tokens.font.family.body,

    '--local-exceptions-row-height': '34px',
    '--local-exceptions-row-padding-x': tokens.spacing.lg,
    '--local-exceptions-row-gap': tokens.spacing.sm,
    '--local-exceptions-divider': tokens.color.border.secondary,
    // Inherited rows are not this record's data; a faint wash separates them without a second border.
    '--local-exceptions-row-inherited-bg': tokens.color.background.secondarySubtle,

    // Fixed lane so every date starts on the same x whether its badge says SKIP or ADD.
    '--local-exceptions-badge-lane': '34px',
    '--local-exceptions-badge-radius': tokens.radius.xs,
    '--local-exceptions-badge-padding-x': tokens.spacing.xs,
    '--local-exceptions-badge-font-size': '9px',
    '--local-exceptions-badge-font-weight': tokens.font.weight.bold,
    '--local-exceptions-badge-letter-spacing': '0.06em',
    // Amber removes work, green adds it — the same pairing the exception popover's impact note uses.
    '--local-exceptions-badge-skip-bg': tokens.componentColors.utility.warning50,
    '--local-exceptions-badge-skip-color': tokens.componentColors.utility.warning700,
    '--local-exceptions-badge-add-bg': tokens.componentColors.utility.success50,
    '--local-exceptions-badge-add-color': tokens.componentColors.utility.success700,

    '--local-exceptions-date-color': tokens.color.text.primary,
    '--local-exceptions-date-font-size': tokens.font.size.textXs,
    '--local-exceptions-date-font-weight': tokens.font.weight.medium,

    '--local-exceptions-reason-color': tokens.color.text.tertiary,
    '--local-exceptions-reason-font-size': '11px',

    '--local-exceptions-lock-color': tokens.color.foreground.quaternary,
    '--local-exceptions-lock-size': '10px',

    '--local-exceptions-chip-radius': tokens.radius.xs,
    '--local-exceptions-chip-border': tokens.color.border.primary,
    '--local-exceptions-chip-color': tokens.color.text.tertiary,
    '--local-exceptions-chip-padding-x': tokens.spacing.xs,
    '--local-exceptions-chip-font-size': '10px',
    '--local-exceptions-chip-font-weight': tokens.font.weight.semibold,

    '--local-exceptions-remove-color': tokens.color.foreground.quaternary,
    '--local-exceptions-remove-hover-color': tokens.color.foreground.errorPrimary,
    '--local-exceptions-remove-size': '20px',

    '--local-exceptions-empty-color': tokens.color.text.tertiary,
    '--local-exceptions-empty-font-size': tokens.font.size.textXs,
    '--local-exceptions-empty-padding-y': tokens.spacing.md,
  },
};
